import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import { company } from '@/config/company';

import { activeSocials, socialIcons } from './icons';

/** Round outlined links to each configured social profile; renders nothing if none. */
export function SocialIconLinks() {
  if (activeSocials.length === 0) return null;
  return (
    <Stack direction="row" spacing={2}>
      {activeSocials.map((s) => {
        const Icon = socialIcons[s.platform];
        return (
          <IconButton
            key={s.platform}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${company.brandName} on ${s.label}`}
            sx={{
              border: 1,
              borderColor: 'divider',
              bgcolor: 'background.paper',
              color: 'text.secondary',
              transition: 'all 150ms',
              '&:hover': {
                color: 'primary.contrastText',
                bgcolor: 'primary.main',
                borderColor: 'primary.main',
              },
            }}
          >
            <Icon sx={{ fontSize: 18 }} />
          </IconButton>
        );
      })}
    </Stack>
  );
}
